import { useState } from "react";
import { faqList } from "@/mocks/faqs";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string>(faqList[0].id);

  return (
    <section id="faq" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题 · 打不开先看这里"
          desc="大多数访问问题都能通过以下几条说明解决，看完还不行就换一条线路再试。"
          icon="ri-question-answer-line"
        />

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-[1.6fr_1fr] lg:gap-6">
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            {faqList.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="border-b border-background-200 last:border-b-0">
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? "" : item.id)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-background-100 md:px-5"
                  >
                    <span className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        Q
                      </span>
                      <span className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                    </span>
                    <i
                      className={`${
                        open ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-500"
                      } shrink-0 text-xl`}
                    ></i>
                  </button>
                  {open ? (
                    <div className="px-4 pb-5 pl-14 md:px-5 md:pl-[60px]">
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>

          <div className="flex flex-col gap-4">
            <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-bookmark-3-line text-xl"></i>
              </span>
              <h3 className="mt-3 text-base font-bold text-foreground-950">防走丢小贴士</h3>
              <ul className="mt-3 space-y-2.5">
                {[
                  "把本页加入浏览器书签，或用 App 添加到主屏幕",
                  "同时收藏至少 2 条以上备用线路",
                  "遇到打不开时先刷新本页查看最新状态",
                ].map((tip) => (
                  <li key={tip} className="flex items-start gap-2 text-sm leading-relaxed text-foreground-700">
                    <i className="ri-check-line mt-0.5 shrink-0 text-accent-600"></i>
                    {tip}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-background-200 bg-secondary-100 p-5">
              <h3 className="text-base font-bold text-secondary-900">还找不到入口？</h3>
              <p className="mt-2 text-sm leading-relaxed text-secondary-900/80">
                回到页面顶部的「线路状态」区，逐条切换线路通常就能恢复访问。
              </p>
              <a
                href="#lines"
                className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-secondary-600"
              >
                <i className="ri-route-line text-base"></i>
                前往线路状态
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}